import React from "react";
import classNames from "classnames";
import * as c from "./landingPages.module.scss";
import Layout from "@components/layout";
import { BusinessPageHeader } from "@components/pages/landingPages/businessPageHeader";
import { getLandingPageSections } from "@templates/landingPages/landingPageSections";

const BusinessPage = ({ contentfulLandingPage }) => {
  const { pageHeader, actionSections, sections } = contentfulLandingPage;
  const { sectionComponents, actionSectionsComponents } = getLandingPageSections({
    sections,
    actionSections,
    className: c,
  });

  return (
    <Layout
      navColorVariant={pageHeader?.darkBackground ? "cream-100" : pageHeader?.backgroundColor?.value || "default"}
      className={classNames(c.pageWrapper, "cream-100")}
    >
      <BusinessPageHeader pageHeaderData={pageHeader} />

      <div className={c.sections}>
        {sectionComponents}

        {actionSectionsComponents}
      </div>
    </Layout>
  );
};

export default BusinessPage;
